import { ValuationResource, ValuationSchema } from '../Api/Valuation'
import { OfferToPurchaseResource } from '../Api/OfferToPurchase'

const relations = [
    'vehicle', 
    'vehicle.valuations', 
    'vehicle.currentInstance', 
    'vehicle.offersToPurchase', 
    'vehicle.offersToPurchase.instance', 
    'vehicle.offersToPurchase.contact', 
    'vehicle.offersToPurchase.createdBy', 
    'createdBy', 
    'capData.historicValuations'
];

export default {
    namespaced: true,
    state: {
        current: null,
    },   
    mutations: {
        set(state, valuation) {
            state.current = valuation;
        },
        addOffer(state, offer) {
            state.current.vehicle.offers_to_purchase.unshift(offer);
        },
        removeOffer(state, offer) {
            state.current.vehicle.offers_to_purchase = state.current.vehicle.offers_to_purchase.filter(item => {
                return item !== offer
            })
        }
    },
    actions: {
        load(context, id) {
            return new Promise((resolve, reject) => {
                ValuationResource.find(id, { with: relations }).then(response => {
                    let valuation = new ValuationSchema(response.data);
                    context.commit('set', valuation);
                    resolve();
                }, (e) => { handleApiError(e, reject) });
            });
        },
        saveOffer(context, { offer, vehicle_id }) {
            return new Promise((resolve, reject) => {
                let params = {
                    with: ['vehicle', 'contact', 'instance']
                }

                OfferToPurchaseResource.forVehicle(vehicle_id).store(offer, params).then(response => {
                    context.commit('addOffer', response.data)
                    resolve(response.data)
                }, e => { handleApiError(e); reject(e) });
            })
        },
        destroyOffer(context, offer) {
            return new Promise((resolve, reject) => {
                OfferToPurchaseResource.forVehicle(offer.vehicle_id).destroy(offer.id).then(response => {
                    context.commit('removeOffer', offer);
                    resolve();
                }, e => { reject(e); handleApiError(e) })
            })
        }
    }
}